import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

interface Props {
  open: boolean;
  fromUserName?: string;
  onAccept: () => void;
  onDecline: () => void;
}

const ScreenShareConsent: React.FC<Props> = ({ open, fromUserName, onAccept, onDecline }) => {
  return (
    <Dialog open={open} onClose={onDecline} maxWidth="xs" fullWidth>
      <DialogTitle>Prośba o udostępnienie ekranu</DialogTitle>
      <DialogContent>
        <Typography>
          {fromUserName || 'Administrator'} prosi o jednorazowe udostępnienie Twojego ekranu.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDecline}>Odmów</Button>
        <Button onClick={onAccept} variant="contained">Udostępnij</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScreenShareConsent;


